import React from 'react'
import HeatMarker from './HeatMarker'
import forOwn from 'mout/object/forOwn'
import values from 'mout/object/values'
import contains from 'mout/array/contains'
import sortByPropText from '../../../../helpers/content/manageSets/sortByPropText';
import getHeat from '../../../../helpers/assessment/getHeat';


export default function PrecisionBar ({preciseItems, byItem, assessmentSubtests}) {
  let heatMarkers = []
  let mathSubtestId
  forOwn(assessmentSubtests, (val, key) => {
    if (val.displayName === 'Math') {
      mathSubtestId = key
    }
  })
  const items = sortByPropText(values(byItem[mathSubtestId]), 'index')
  const questionMarkerPositions = {
    1: {left: '-6px'},
    20: {left: '44px'},
    40: {left: '97px'},
    60: {left: '150px'},
  }
  items.forEach((item, n) => {
    let heat = getHeat(item.raw, item.possible)
    if (!contains(preciseItems, n + 1)) {
      heat = 0
    }
    heatMarkers.push(
      <HeatMarker heat={heat} itemNumber={n + 1} key={`prec${n}`}/>
    )
    if (questionMarkerPositions[n + 1]) {
      heatMarkers.push(
        <span 
          className='questionMarker' 
          style={questionMarkerPositions[n + 1]} 
          key={`precMark${n}`}>{n + 1}
        </span>
      )
    }

  })


  return (
    <div className="skill-graphs ">
      <div className="math" style={{marginTop: '50px', marginLeft: '8px'}}>
        <h3>Math</h3>
        <ol className="heatMap" style={{width: '160px'}}>
          {heatMarkers}
        </ol>
      </div>
    </div>
  )
}


// WEBPACK FOOTER //
// ./src/components/Assessment/AssessPrint/TestTaking/PrecisionBar.js